import { AppError } from "./app-error";

export class NotFoundError extends AppError {}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/pages/common/not-found-error.ts